import { render, staticRenderFns } from "./LinkExpenses.vue?vue&type=template&id=ad6e9494"
import script from "./LinkExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkExpenses.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports